import React, { useState, useEffect } from "react";
import axiosStrapiInstance from "../../axiosStrapi";
import blogButtonImg from "../../assets/blogButton.svg";
import ReactPaginate from "react-paginate";
import BlogContainer from "./BlogContainer";
import Loader from "./Loader";
import CustomHeading from "./CustomHeading";

const CustomBlogContainer = ({
  type = "Blogs", // by Default type is blogs
  paddingX = "4%", // for giving left right padding
}) => {
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axiosStrapiInstance.get(
          `/api/blogs?filters[Type][$eq]=${type}&populate[headerImages][populate]=*&pagination[page]=${page}&pagination[pageSize]=6&sort[createdAt]=desc`
        );
        setTotalPages(response?.data.meta.pagination.pageCount);
        setData(response?.data?.data || []);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching data from Strapi:", error);
      }
    };
    fetchData();
  }, [page]);
  return (
    <div
      style={{
        lineHeight: "1.6",
        paddingBottom: "0%",
        padding: paddingX && `4% ${paddingX} 0% ${paddingX}`,
      }}
      className="font-Lato"
    >
      <CustomHeading
        text={"Our "}
        spanText={type}
        heartTop="0px"
        heartPosition="absolute"
        heartHeight="56px"
        heartWidth="56px"
        customImg={blogButtonImg}
        spanTextColor="#d31c4f"
        textSize="48px"
      />
      <div className="mb-[200px] sm:mb-[100px] flex flex-col items-center relative w-full mt-[2.5rem]">
        {loading ? (
          <Loader></Loader>
        ) : data?.length > 0 ? (
          <BlogContainer data={data} />
        ) : (
          <div className="w-full font-Lato text-3xl sm:text-5xl font-medium text-[#d31c4f] min-h-[250px] sm:min-h-[450px] flex justify-center items-center">
            Currently No Data
          </div>
        )}

        {(!data?.length || totalPages > 1) && (
          <ReactPaginate
            className="flex text-black shadow-slate-200 pagination absolute bottom-[-100px] rounded-lg shadow-lg my-6 px-3 py-2 flex-row gap-2 justify-center min-w-[120px]"
            breakLabel="..."
            nextLabel=">"
            onPageChange={(event) => setPage(event.selected + 1)}
            pageRangeDisplayed={4}
            pageCount={totalPages}
            previousLabel="<"
          />
        )}
      </div>
    </div>
  );
};

export default CustomBlogContainer;
